import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreDirectivesModule } from '@core/directives/directives';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { FlatpickrModule } from 'angularx-flatpickr';
import { SelectFieldComponent } from 'app/main/pages/contract-control/editable-fields/select-field/select-field.component';
import { TextFieldComponent } from 'app/main/pages/contract-control/editable-fields/text-field/text-field.component';
import { IField } from 'app/main/pages/settings/documenttype/document-type-settings-modal/document-type-settings.dto';
import { ExtractSenderDetailPipe } from 'app/pipes/documents-right-sidebar-pipes/extract-sender-details.pipe';
import { MomentPipe } from 'app/pipes/moment.pipe';
import { UserTimeZoneFormatPipe } from 'app/pipes/user-timezone-format.pipe';
import { TranslocoRootModule } from 'app/transloco-root.module';
import { IDocumentDetailRootDTO, Tag } from '../../../dto/document-details.dto';
import { ConfirmationMessageComponent } from './confirmation-message/confirmation-message.component';
import { ContractControlFieldComponent } from './contract-control-field/contract-control-field.component';
import { DueDateFieldComponent } from './due-date-field/due-date-field.component';
import { InvitationMessageComponent } from './invitation-message/invitation-message.component';
import { LanguageFieldComponent } from './language-field/language-field.component';
import { SigningDeadlineComponent } from './signing-deadline/signing-deadline.component';
import { SigningReminderComponent } from './signing-reminder/signing-reminder.component';
import { StatusUpdatedFieldComponent } from './status-updated-field/status-updated-field.component';
import { TagsFieldComponent } from './tags-field/tags-field.component';
import { TemplateRolesFieldComponent } from './template-roles-field/template-roles-field.component';
import { VisibilityFieldComponent } from './visibility-field/visibility-field.component';
import { DocumentKeyFieldComponent } from './document-key-field/document-key-field.component';
import { BccSettingsFieldComponent } from './bcc-settings-field/bcc-settings-field.component';
import { AllowUploadFileFieldComponent } from './allow-upload-file-field/allow-upload-file-field.component';
import { SenderConfirmationTypeFieldComponent } from './sender-confirmation-type-field/sender-confirmation-type-field.component';
import { ExternalChatFieldComponent } from './external-chat-field/external-chat-field.component';
import { CurrencyFieldComponent } from './currency-field/currency-field.component';
import { TemplateType } from 'app/main/pages/templates/template.dto';
import { AddonPermissionPipe } from 'app/pipes/addon-permission.pipe';

export interface FieldActionEvent {
  action: string;
  data?: any;
}

@Component({
  selector: 'app-dynamic-field',
  standalone: true,
  imports: [
    CommonModule,
    CoreDirectivesModule,
    TranslocoRootModule,
    NgSelectModule,
    TextFieldComponent,
    SelectFieldComponent,
    NgbTooltipModule,
    ExtractSenderDetailPipe,
    FlatpickrModule,
    MomentPipe,
    UserTimeZoneFormatPipe,
    FormsModule,
    ReactiveFormsModule,
    VisibilityFieldComponent,
    TemplateRolesFieldComponent,
    ContractControlFieldComponent,
    DueDateFieldComponent,
    StatusUpdatedFieldComponent,
    TagsFieldComponent,
    SigningDeadlineComponent,
    SigningReminderComponent,
    DocumentKeyFieldComponent,
    LanguageFieldComponent,
    ExternalChatFieldComponent,
    InvitationMessageComponent,
    ConfirmationMessageComponent,
    BccSettingsFieldComponent,
    AllowUploadFileFieldComponent,
    SenderConfirmationTypeFieldComponent,
    CurrencyFieldComponent,
    AddonPermissionPipe
  ],
  templateUrl: './dynamic-field.component.html',
  styleUrl: './dynamic-field.component.scss'
})

export class DynamicFieldComponent {

  @Input() field: IField;
  @Input() formGroup!: FormGroup;
  @Input() isDueDateDisabled: boolean;
  @Input() shouldShowDueDateField: boolean = false;
  @Input() disableFlatpickr: ((date: Date) => boolean)[];
  @Input() documentData: IDocumentDetailRootDTO;
  @Input() tags: Tag[] = [];
  @Input() hasFullAccess = false;
  @Input() canEdit = false;
  @Input() sectionName: string = 'document';
  @Output() fieldAction = new EventEmitter<FieldActionEvent>();
  public templateType = TemplateType;

}
